var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BhBaseMenu,_vm._g(_vm._b({staticClass:"view-tabs-menu"},'BhBaseMenu',{ ..._vm.$attrs, ..._vm.$props },false),{ ..._vm.$listeners, ..._vm.$emit }))
}
var staticRenderFns = []

export { render, staticRenderFns }